import _defineProperty from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React from 'react';
import { Box } from '@hub/box';
import { CoreContainer } from '@hub/core-container';
import { MegaMenuItem } from './mega-menu-item';
import { Grid, GridItem } from '@hub/grid';
import { Text } from '@hub/text';
import { Feature } from './feature';
import { MenuLink } from '../../../../packages/hub/navigation/src/menu-link';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const MegaMenu = _ref => {
  var _feature$link;
  let {
    items,
    feature,
    onClickLink,
    onClickFeature
  } = _ref;
  return /*#__PURE__*/_jsxs(CoreContainer, {
    sx: {
      fontSize: 'font-sm',
      paddingY: 'spacing-md',
      display: 'flex',
      minHeight: 'size-4xl',
      justifyContent: 'space-between'
    },
    "data-id": "mega-menu_index_MegaMenu_CoreContainer",
    children: [/*#__PURE__*/_jsxs(Grid, {
      templateColumns: [null, null, 'repeat(3, 1fr)'],
      gap: ['spacing-2xl', 'spacing-2xl', 'spacing-none', 'spacing-none'],
      "data-id": "mega-menu_index_MegaMenu_CoreContainer_Grid",
      children: [(feature === null || feature === void 0 || (_feature$link = feature.link) === null || _feature$link === void 0 ? void 0 : _feature$link.mobileLabel) && /*#__PURE__*/_jsxs(GridItem, {
        sx: {
          width: 'size-17',
          display: ['block', null, 'none']
        },
        "data-id": "mega-menu_index_MegaMenu_GridItem",
        children: [/*#__PURE__*/_jsx(Text, {
          tone: "strong",
          "data-id": "mega-menu_index_MegaMenu_GridItem_Text",
          children: feature.mobileTitle
        }), /*#__PURE__*/_jsx(MenuLink, {
          href: feature.link.url,
          onClick: event => onClickFeature === null || onClickFeature === void 0 ? void 0 : onClickFeature(event),
          "data-id": "mega-menu_index_MegaMenu_GridItem_MenuLink",
          children: feature.link.mobileLabel
        })]
      }), items === null || items === void 0 ? void 0 : items.map((item, i) => /*#__PURE__*/_jsx(GridItem, {
        sx: {
          width: 'size-17'
        },
        "data-id": "mega-menu_index_MegaMenu_GridItem",
        children: /*#__PURE__*/_jsx(MegaMenuItem, {
          onClick: onClickLink,
          megaMenuItem: item,
          "data-id": "mega-menu_index_MegaMenu_GridItem_MegaMenuItem"
        })
      }, i))]
    }), feature && /*#__PURE__*/_jsx(Box, {
      sx: {
        maxWidth: [0, 0, 0, '25%'],
        flexBasis: [0, 0, 0, '25%'],
        display: ['none', null, null, 'initial']
      },
      "data-id": "mega-menu_index_MegaMenu_Box",
      children: /*#__PURE__*/_jsx(Feature, _objectSpread(_objectSpread({}, feature), {}, {
        onClick: onClickFeature ? event => onClickFeature(event) : undefined,
        "data-id": "mega-menu_index_MegaMenu_Box_Feature"
      }))
    })]
  });
};
export default MegaMenu;